import React from 'react'
import NavWidget from '../../../../widget/Nav/NavWidget'
import SidebarWidget from '../../../../widget/SidebarWidget/SidebarWidget'
import BankIntegrationPageWidget from './bankIntegrationPageWidget'
import Cookies from 'js-cookie';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { Spinner } from 'evergreen-ui';


function BankIntegration() {
const history = useHistory()
const managerType = Cookies.get('managerType');
if(managerType ==='sub'){
  history.push(`/dashboard`);
  return <Spinner/>
}

  return (
    <div>
        <NavWidget/>
        <div className='row '>
            <div className='col s12 l2 transparent'>
                <SidebarWidget/>
            </div>
            <div className='col s12 l10 '>
                   <BankIntegrationPageWidget/>
                   {/* <CardIntegrationPageWidget/>
                   <CardSettingsWidget/> */}
            </div>
        </div>
    </div>
  )
}

export default BankIntegration